(function () {
  'use strict';

  /* @ngdoc object
   * @name cadastros.macro
   * @description
   *
   */
  angular
    .module('cadastros.macro', [
      'ui.router',
      'ui.bootstrap',
      'blockUI',
      'restangular',
      'httpServiceV3gModule',
      'ConstantVfiltroModule',
      'ServiceVfiltroModule',
      'FactoryVfiltroModule',
      'ObjetosVfiltroModule',
      'safetyModule',
      'ngSanitize'
    ]);
}());
